// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__XKPZF","heading":"Terms_heading__aLrA1","terms":"Terms_terms__R15ru","headingSecondry":"Terms_headingSecondry__qXsac","content":"Terms_content__IWsKU"};